import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "svg-icon-ArrowRightBig",
  "use": "svg-icon-ArrowRightBig-usage",
  "viewBox": "0 0 24 43",
  "content": "<symbol viewBox=\"0 0 24 43\" xmlns=\"http://www.w3.org/2000/svg\" id=\"svg-icon-ArrowRightBig\"><path d=\"M2.8 43L24 21.5 2.8 0 0 2.84 18.4 21.5 0 40.16\" opacity=\".8\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol